module.exports = __webpack_public_path__ + "media/images/pages/fcr-7de22f09365cad33cba79f78a2b9bb97.png";